"use strict";
/**
 * Created by Ning Jiang on 8/16/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShakingDisplayObject = void 0;
const gsap_1 = require("gsap");
class ShakingDisplayObject {
    get object() {
        return this._object;
    }
    constructor(displayObject) {
        this._stopped = true;
        this._object = displayObject;
    }
    shake(frequency, maxOffset) {
        this._stopped = false;
        gsap_1.TweenLite.fromTo(this._object, frequency, {
            x: this._object.x + ShakingDisplayObject.getShakeOffset(maxOffset),
            y: this._object.y + ShakingDisplayObject.getShakeOffset(maxOffset)
        }, {
            x: this._object.x,
            y: this._object.y,
            onComplete: () => {
                if (this._stopped) {
                    return;
                }
                this.shake(frequency, maxOffset);
            },
            clearProps: "x,y"
        });
    }
    stopShake() {
        this._stopped = true;
    }
    static getShakeOffset(offset) {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }
}
exports.ShakingDisplayObject = ShakingDisplayObject;
//# sourceMappingURL=ShakingDisplayObject.js.map